module.exports = __webpack_public_path__ + "media/images/details__prizeBox__season__third-88d17bd154ab14a235ec129e19d09e8b.png";